module.exports = __webpack_public_path__ + "img/icon_manejo_de_referidos.32a091de.svg";